/**
 * Main JavaScript File
 */
import $ from 'jquery';


// Template Parts
import { header } from './template-parts/header/header'
import { headerLp1 } from './template-parts/header/header-lp1'

// ACF Blocks
import { initTestimonialsSlider } from './template-parts/blocks/testimonials-slider'
import { initLogosSlider } from './template-parts/blocks/logos-slider'
import { initImagesSlider } from './template-parts/blocks/images-slider'

import { videoBlock, videoBlockPopup , videoPopup , imagePopup } from './template-parts/blocks/video'
import { videoBanner } from './template-parts/blocks/video-banner'
import { counterNumbers } from './template-parts/blocks/counter-numbers'
import { initTeamBlock } from './template-parts/blocks/team-block'
import { initResourcesSlider } from './template-parts/blocks/resources-slider-block'
import { initTabsBlock } from './template-parts/blocks/tabs'
import { initTextImageSlider } from './template-parts/blocks/text-image-slider'
import { initDownloadsBlock } from './template-parts/blocks/downloads'

// Components
import { appearence } from './components/animations/appearence'
import { popup } from './components/popup'
import { filters } from './components/filters'
import { accordion } from './components/accordion'

// Utils
//import { blogLoadMore } from './utils/blog-loadmore'

// Components
appearence()

// Template Parts
header()
headerLp1()

// ACF Blocks
initTestimonialsSlider()
initLogosSlider()
videoBlock()
videoBlockPopup()
videoBanner()
imagePopup()
counterNumbers()

initImagesSlider()
filters()
initResourcesSlider()
initTabsBlock()
initTextImageSlider()
initTeamBlock()
initDownloadsBlock()

// Components
popup()
accordion()

$(document).ready(function () {
    videoPopup()
    $('.content-block').find('table').wrap('<div class="table-wrapper"></div>');
    $('.content-block').find('iframe').wrap('<div class="iframe-wrapper"></div>');
})